import { BaseService } from '../base';

/**
 * Produto do catálogo do InsureMO (`productList` com `ProductTypeId: 3`).
 *
 * É a lista de produtos que podem ser vinculados a uma corretora — diferente do
 * registry de wizards em `app/config/products.config.ts`, que é hardcoded e só
 * cobre os produtos com fluxo de cotação próprio.
 */
export interface ProductCatalogItem {
  id: string;
  name: string;
  description?: string;
  /** BusinessCode, ex.: '140001'. É a chave usada na Party_products. */
  code: string;
  /** HOME_INSURANCE, BUSINESS_INSURANCE, GROUP_LIFE_INSURANCE ou OTHER. */
  category: string;
  productElementId?: string;
}

export class ProductsService extends BaseService {
  async list(): Promise<{
    success: boolean;
    data?: ProductCatalogItem[];
    error?: string;
  }> {
    try {
      const response = await this.get(
        '/portal/v1/products',
        {},
        import.meta.env.VITE_API_URL
      );

      return await this.handleJsonResponse<ProductCatalogItem[]>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : 'Erro ao carregar produtos',
      };
    }
  }
}

export const productsService = new ProductsService();
